
import ToggleOnIcon from '@mui/icons-material/ToggleOn'
import ToggleOffIcon from '@mui/icons-material/ToggleOff'
import { IconButton, Tooltip } from "@mui/material"
import { EditIcon } from "lucide-react"
import DeleteForeverIcon from '@mui/icons-material/DeleteForever'
import { TableShimmer } from "../../../../ShimmerUI"
import NotFound from "../../../../Notfound"

type BoardManagmentTableProps = {
    firstColumName?: string,
    secondColumName?: string,
    data?: any[],
    loadingForShimmer?: boolean,
    handleToggleDialogOpen?: () => void,
    handleEditBoard?: (board: any) => void,
    setSelectedBoardForDelete?: (board: any) => void,
    setDeleteDialog?: (open: boolean) => void,
    setToggleData?: (data: any) => void,
    setOpenToggle?: (open: boolean) => void,
}
const BoardManagmentTable = ({ firstColumName, secondColumName, data, loadingForShimmer, handleToggleDialogOpen, handleEditBoard, setSelectedBoardForDelete, setDeleteDialog, setToggleData, setOpenToggle }: BoardManagmentTableProps) => {
    return (
        <div className="overflow-hidden bg-white rounded-lg shadow">
            <div className="overflow-x-auto">
                <table className="min-w-full">
                    <thead className="bg-gray-50">
                        <tr className="text-sm text-left text-white uppercase bg-[#5BC0BE]">
                            <th
                                className="px-6 py-3 "

                            >
                                <div className="flex items-center">
                                    {firstColumName}

                                </div>
                            </th>
                            <th
                                className="px-6 py-3 cursor-pointer"

                            >
                                <div className="flex items-center">
                                    {secondColumName}

                                </div>
                            </th>
                            <th className="px-6 py-3 text-center">Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {loadingForShimmer ? (
                            <TableShimmer columns={10} />
                        ) : data?.length === 0 ? (
                            <tr>
                                <td colSpan={20} className="p-4 text-center">
                                    <NotFound />
                                </td>
                            </tr>
                        ) : (
                            data?.map(board => (
                                <tr
                                    key={board._id || board.id}
                                    className="hover:bg-gray-50"
                                >
                                    <td className="px-6 py-4 min-w-[200px]">
                                        <span role="button" tabIndex={0}>
                                            {board?.name || 'NA'}
                                        </span>
                                    </td>

                                    <td className="px-6 py-4">{board?.description || 'NA'}</td>

                                    <td className="px-6 py-4 text-center">
                                        <div className="flex items-center justify-center gap-1">
                                            <Tooltip
                                                title={board?.isActive ? 'Deactivate' : 'Activate'}
                                                arrow
                                            >
                                                <IconButton
                                                    onClick={() => {
                                                        setToggleData(board)
                                                        setOpenToggle(true)
                                                    }}
                                                >
                                                    {board?.isActive === true ? (
                                                        <ToggleOnIcon
                                                            sx={{ fontSize: 32, color: '#10b981' }}
                                                        />
                                                    ) : (
                                                        <ToggleOffIcon
                                                            sx={{ fontSize: 32, color: '#ef4444' }}
                                                        />
                                                    )}
                                                </IconButton>
                                            </Tooltip>
                                            {/* edit certificate manager */}
                                            <Tooltip title="Edit Certificate" arrow>
                                                <IconButton
                                                    onClick={() => handleEditBoard?.(board)}
                                                    sx={{
                                                        color: '#10b981',
                                                        '&:hover': {
                                                            bgcolor: 'rgba(16, 185, 129, 0.08)',
                                                        },
                                                    }}
                                                >
                                                    <EditIcon />
                                                </IconButton>
                                            </Tooltip>
                                            {/* delete certificate manager */}
                                            <Tooltip title="Delete Certificate" arrow>
                                                <IconButton
                                                    onClick={() => { setSelectedBoardForDelete(board); setDeleteDialog(true) }}
                                                    sx={{
                                                        color: '#dc2626',
                                                        '&:hover': {
                                                            bgcolor: 'rgba(220, 38, 38, 0.08)',
                                                        },
                                                    }}
                                                >
                                                    <DeleteForeverIcon sx={{ fontSize: 24 }} />
                                                </IconButton>
                                            </Tooltip>
                                        </div>
                                    </td>

                                </tr>
                            ))
                        )}
                    </tbody>
                </table>
            </div>
        </div>
    )
}

export default BoardManagmentTable